/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LocalObjectStoreTransferConfig = {
    container: string;
    prefix: string;
    provider?: LocalObjectStoreTransferConfig.provider;
};

export namespace LocalObjectStoreTransferConfig {

    export enum provider {
        LOCAL = 'local',
    }


}

